import ChartBaseController from "./chart_base_controller";

export default class ChartBarComparisonController extends ChartBaseController {
  seriesData = null;

  static values = {
    ...ChartBaseController.values,
    xKey: String,
    series: Array,
    data: Array,
  }

  formatData(data) {
    this.seriesData = data;
    const allGroups = new Set();
    data.forEach(term => {
      Object.keys(term.absences).forEach(absence => {
        allGroups.add(absence);
      });
    });

    const sortedGroups = Array.from(allGroups).sort((a, b) => a - b);

    return sortedGroups.map(group => {
      const groupObj = { group }

      data.forEach(term => {
        groupObj[term.term_id] = term.absences[group] || 0;
      });
      return groupObj;
    });
  }

  getChartOptions(data) {
    const options = super.getChartOptions(data);
    options.series = this.formatSeries(this.seriesData);
    return options;
  }

  formatSeries(selections) {
    return selections.map((selection) => ({
      type: 'bar',
      label: {
        formatter: function(params) {
          return params.value.toString();
        },
        enabled: true,
        fontSize: 12,
        placement: 'outside-end',
        color: '#333333',
      },
      xKey: this.xKeyValue,
      yKey: selection.term_id,
      yName: selection.term_name,
      cornerRadius: 4,
      fillOpacity: 1,
    }));
  }
}
